'use strict';
const ansiRegex = require('ansi-regex');

module.exports = input => typeof input === 'string' ? input.replace(ansiRegex(), '') : input;



//////////////////
// WEBPACK FOOTER
// ./~/yargs/~/strip-ansi/index.js
// module id = 1143
// module chunks = 0